var version = "2.5.2";
export { version };